import React, { useState } from "react";
import "./DocumentUpload.css";
import Docupload from "../../Docupload/Docupload";

interface DropFileInputProps {
  folderPath: string;
}
const DocumentUpload: React.FC<DropFileInputProps> = ({
  folderPath,
}) => {
  const [fileList, setFileList] = useState<File[]>([]);

  const onFileChange = (files: File[]) => {
    console.log(files);
    setFileList(files);
    console.log("Annex Report Files:", files);
  };

  const onFileDrop = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(e.target.files || []);
    const updatedList = [...fileList, ...newFiles];
    setFileList(updatedList);
    onFileChange(updatedList);
  };

  const fileRemove = (file: File) => {
    const updatedList = fileList.filter((item) => item !== file);
    setFileList(updatedList);
    onFileChange(updatedList);
  };

  return (
    <div className="p-4 annex-a-upload-container">
      <Docupload onFileChange={onFileChange} disabled={false} folderPath={folderPath} />
    </div>
  );
};

export default DocumentUpload;
